import * as React from "react";
import axios from "axios";
import { DataTable } from "src/components/common";
import { Button, IconButton } from "src/components/buttons";
import { Icon } from "src/components/icons/Icon";
import { CircleArrowRight, SquarePen, Trash2 } from "lucide-react";
import { Tooltip } from "antd";
// TODO: is this whole file anti-pattern?
const apiUrl = process.env.REACT_APP_API_URL;
const API = {
	getCollection<T>(collectionName: string): Promise<T[]> {
		return axios
			.get(`${apiUrl}/${collectionName}`)
			.then((response) => response.data as T[]);
	},
};

interface IListViewProps<T> {
	columnDefinitions: any[];
	collectionName: string;
	actionTitles?: string[];
	onItemNavigate?: (arg0: T) => void;
	onItemEdit?: (arg0: T) => void;
	onItemRemove?: (arg0: T) => void;
	onRowClick?: (arg0: any) => void;
	data?: any[];
	navigationColumn?: INavigateColumn;
	loading?: boolean;
	filtered: any[];
	storageKey?: string;
}

interface IListViewState<T> {
	listData: T[];
	filtered: any[];
}

interface INavigateColumn {
	name: string;
	path: string;
}

class ListView<T> extends React.Component<
	IListViewProps<T>,
	IListViewState<T>
> {
	public constructor(props: IListViewProps<T>) {
		super(props);
		this.state = { listData: [], filtered: [] };
	}

	public componentDidMount() {
		if (this.props.data) {
			this.setState({ listData: this.props.data });
		} else {
			API.getCollection<T>(this.props.collectionName).then((listData) => {
				this.setState({ listData });
			});
		}
		this.setState({ filtered: this.props.filtered });
	}

	public render() {
		let columns;
		if (this.props.navigationColumn !== undefined) {
			columns = this.addColumn(
				this.props.columnDefinitions,
				this.props.navigationColumn
			);
		} else {
			columns = this.addColumn(this.props.columnDefinitions);
		}

		return (
			<DataTable
				data={this.state.listData}
				columns={columns}
				loading={this.props.loading}
				filterable={true}
				onRowClick={this.props.onRowClick}
				filtered={this.state.filtered}
				onFilteredChange={(filtered: any) => this.setState({ filtered })}
				noDataText="No rows to display"
				storageKey={this.props.storageKey}
			/>
		);
	}

	private addColumn = (columns: any[], navigateColumn?: INavigateColumn) => {
		const newColumns = [...columns];

		newColumns.push({
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			accessor: "Actions",
			Cell: (rowInfo: any) => (
				<React.Fragment>
					{this.renderNavigateButton(rowInfo)}
					{this.renderEditButton(this.props.onItemEdit, rowInfo)}
					{this.renderDeleteButton(this.props.onItemRemove, rowInfo)}
				</React.Fragment>
			),
			Filter: () => (
				<Button
					className="btn-outline-primary"
					onClick={() =>
						this.setState({ filtered: [{ id: "isActive", value: "Active" }] })
					}
				>
					Clear
				</Button>
			),
			filterMethod: () => {
				return;
			},
			id: "Actions",
		});
		return newColumns;
	};

	private onNavigateClick = (e: any, item: T) => {
		if (this.props.onItemNavigate !== undefined) {
			e.stopPropagation();
			this.props.onItemNavigate(item);
		}
	};

	private onEditClick = (e: any, item: T) => {
		if (this.props.onItemEdit !== undefined) {
			e.stopPropagation();
			this.props.onItemEdit(item);
		}
	};

	private onDeleteClick = (e: any, item: T) => {
		if (this.props.onItemRemove !== undefined) {
			e.stopPropagation();
			this.props.onItemRemove(item);
		}
	};

	private renderNavigateButton = (rowInfo: any) => {
		if (this.props.onItemNavigate !== undefined) {
			return (
				<IconButton
					className="btn btn-link pl-0"
					onClick={(e: any) => {
						this.onNavigateClick(e, rowInfo.original);
					}}
				>
					<Tooltip title="Detail">
						<Icon icon={CircleArrowRight} />
					</Tooltip>
				</IconButton>
			);
		} else {
			return "";
		}
	};

	private renderEditButton = (onItemEdit: any | undefined, rowInfo: any) => {
		if (this.props.onItemEdit === undefined) {
			return "";
		} else {
			return (
				<IconButton
					className="btn btn-link"
					onClick={(e: any) => {
						this.onEditClick(e, rowInfo.original);
					}}
				>
					<Tooltip title="Edit">
						<Icon icon={SquarePen} />
					</Tooltip>
				</IconButton>
			);
		}
	};

	private renderDeleteButton = (
		onItemRemove: any | undefined,
		rowInfo: any
	) => {
		if (this.props.onItemRemove === undefined) {
			return "";
		} else {
			return (
				<IconButton
					className="btn btn-link pr-0"
					onClick={(e: any) => {
						this.onDeleteClick(e, rowInfo.original);
					}}
				>
					<Tooltip title="Delete">
						<Icon icon={Trash2} />
					</Tooltip>
				</IconButton>
			);
		}
	};
}

export default ListView;
